import Rollbar from 'rollbar/dist/rollbar.noconflict.umd';
import App from './App';
// @TODO: Need to decide how we'll load different interfaces (e.g. ClientAPI or Studio)
import * as ViewerInterface from './api/ViewerInterface';
// @TODO: This should not be included in the main bundle, only in the bundle that has the Client API enabled
//        This should be done as part of #1371
import IFrameApi from './api/IFrameApi';
// Initialize Rollbar ASAP to catch any errors
const rollbar = new Rollbar({
    accessToken: 'aaa2e6023bd44012abaff7208b7b36a3',
    captureUncaught: true,
    captureUnhandledRejections: true,
    payload: {
        // @HACK: Attempt to read the global config set by ayvri-website. If it's not there, just use a sane default
        environment: window._rollbarConfig ? window._rollbarConfig.payload.environment : 'development',
    },
});
class ViewerAPI {
    constructor() {
        this._iFrameApi = new IFrameApi();
        this._app = new App();
    }
    initialize(rootElement, assetPath, scene, options) {
        console.assert(rootElement instanceof HTMLElement, 'The rootElement provided to AyvriViewer must be a DOM element');
        console.assert(scene.accountId, 'A valid Scene object must be provided to initialize the AyvriViewer');
        // Strip any trailing slash so that we can build asset URLs by joining with a slash
        if (assetPath.endsWith('/'))
            assetPath = assetPath.slice(0, -1);
        // Set the webpack public path at runtime. This affects dynamic module imports like the Globes and workers.
        // @NOTE: This must be a "free variable", it will not work if we attempt to set window.__webpack_public_path__
        //        See https://gitlab.com/gitlab-org/gitlab-foss/merge_requests/26066
        // eslint-disable-next-line
        __webpack_public_path__ = `${assetPath}/`;
        // Parse query variables
        // @TODO: Viewer shouldn't be doing any url var parsing. This should happen in viewer's parent, which can modify
        //        the scene directly. This should be pretty easy once I'm sure no one is using these two params.
        const urlParams = new URLSearchParams(window.location.search);
        const editedScene = Object.assign({}, scene);
        if (urlParams.has('trailLength'))
            editedScene.trailLength = urlParams.get('trailLength');
        if (urlParams.get('autoplay'))
            editedScene.autoplay = JSON.parse(urlParams.get('autoplay'));
        // Start loading Viewer
        const success = this._app.initialize(rootElement, assetPath, editedScene, options);
        // Once the Viewer has finished loading, expose the interface functions
        const interfaceReadyPromise = ViewerInterface.onceSceneLoaded().then(() => {
            // All exported interface functions will now be available on this object
            Object.assign(this, ViewerInterface);
            // @TODO: This should not execute in the main bundle. We should have a separate bundle that enables the ClientAPI.
            this._iFrameApi.initialize();
        });
        // Main loop
        const renderLoop = timestamp => {
            this._app.tick(timestamp);
            requestAnimationFrame(renderLoop);
        };
        if (success)
            renderLoop(0);
        return interfaceReadyPromise;
    }
}
global.AyvriViewer = new ViewerAPI();
